// validationUtils.ts
import { withFormik } from 'formik';
import * as Yup from 'yup';

// Define Yup validation schema
const validationSchema = Yup.object().shape({
    ratingCriteria: Yup.string().required('Rating Criteria is required'),
    default: Yup.boolean()
});

// Define the enhancer with Formik and Yup
export const withFormikValidation = withFormik({
    mapPropsToValues: () => ({ ratingCriteria: '' }),
    validationSchema,
    validateOnMount: true,
    handleSubmit: () => { },
});
